if (!customElements.get('plan-picker')) {
  customElements.define(
    'plan-picker',
    class PlanPicker extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('click', this.handleClick.bind(this));
        this.addEventListener('change', this.handleChange.bind(this));
        this.addEventListener('keydown', this.handleKeydown.bind(this));
        this.sellingPlanLocation = this.dataset.sellingPlanLocation || 'inside_card';
        this.initializeProductVisibility();
      }

      initializeProductVisibility() {
        // Show the first product by default within the current product group
        const firstProductSimulator = this.querySelector('.plan-picker__radio-simulator.active');
        if (firstProductSimulator) {
          this.showProduct(firstProductSimulator.dataset.productId);
        } else {
          // If no active simulator, show the first product in the current group
          const currentProductGroup = this.closest('.product-group');
          if (currentProductGroup) {
            const firstProduct = currentProductGroup.querySelector('product-info');
            if (firstProduct) {
              firstProduct.classList.remove('hidden');
              firstProduct.classList.add('selected');

              // If using below-list selling plans, initialize them for the first product
              if (this.sellingPlanLocation === 'below_list') {
                const firstProductId = firstProduct.dataset.productId;
                if (firstProductId) {
                  this.updateBelowListSellingPlans(firstProductId);
                }
              }
            }
          }
        }
      }

      handleClick(event) {
        // Don't handle clicks on selling plans
        if (event.target.closest('.plan-picker__selling-plans')) {
          return;
        }

        const target = event.target.closest('.plan-picker__product');
        if (target && target.dataset.productId) {
          // Handle product selection
          this.selectProduct(target);
        }
      }

      handleChange(event) {
        const target = event.target;

        if (target.name.startsWith('selling-plan-')) {
          // Handle selling plan selection
          this.handleSellingPlanChange(target);
        }
      }

      handleKeydown(event) {
        const target = event.target;

        if (target.classList.contains('plan-picker__radio-simulator') && (event.key === 'Enter' || event.key === ' ')) {
          event.preventDefault();
          if (target.dataset.productId) {
            this.selectProduct(target);
          }
        }
      }

      selectProduct(simulator) {
        // Remove active class from all product simulators
        const allSimulators = this.querySelectorAll('.plan-picker__radio-simulator[data-product-id]');
        // allSimulators.forEach((sim) => sim.classList.remove('active'));

        // // Add active class to selected simulator
        // simulator.classList.add('active');

        // Show the selected product
        this.showProduct(simulator.dataset.productId);
      }

      showProduct(productId) {
        // Find the current product group (the one that contains this plan-picker)
        const currentProductGroup = this.closest('.product-group');

        if (currentProductGroup) {
          // Hide all products within the current product group only
          const productsInGroup = currentProductGroup.querySelectorAll('product-info');
          productsInGroup.forEach((product) => {
            product.classList.add('hidden');
            product.classList.remove('selected');
          });

          // Show the selected product within the current group
          const selectedProduct = currentProductGroup.querySelector(`product-info[data-product-id="${productId}"]`);
          if (selectedProduct) {
            selectedProduct.classList.remove('hidden');
            selectedProduct.classList.add('selected');

            // Find the product form within the selected product
            const productForm = selectedProduct.querySelector('.product__info-container .form');

            if (productForm) {
              // Find the first selling plan radio button within the selected product
              const firstSellingPlanRadio = selectedProduct.querySelector('input[name^="selling-plan-"][type="radio"]');

              console.log(firstSellingPlanRadio);

              if (firstSellingPlanRadio) {
                const sellingPlanId = firstSellingPlanRadio.value;
                if (sellingPlanId !== '') {
                  // Remove any existing selling plan hidden input from this form
                  const existingSellingPlanInput = productForm.querySelector('input[name="selling_plan"]');
                  if (existingSellingPlanInput) {
                    existingSellingPlanInput.remove();
                  }

                  // Add the hidden input for the selected selling plan
                  const hiddenInput = document.createElement('input');
                  hiddenInput.type = 'hidden';
                  hiddenInput.name = 'selling_plan';
                  hiddenInput.value = sellingPlanId;
                  productForm.appendChild(hiddenInput);
                  console.log('Added selling plan to form for product:', productId, 'Plan ID:', sellingPlanId);
                }
              }
            }
          }
        } else {
          // Fallback to the old behavior if no product group is found
          const allProducts = document.querySelectorAll('product-info');
          allProducts.forEach((product) => {
            product.classList.add('hidden');
            product.classList.remove('selected');
          });

          const selectedProduct = document.querySelector(`product-info[data-product-id="${productId}"]`);
          if (selectedProduct) {
            selectedProduct.classList.remove('hidden');
            selectedProduct.classList.add('selected');
          }
        }

        // Check if the selected product has selling plans and add hidden input if needed
        this.handleProductSellingPlan(productId);

        // If selling plans are below the list, update the below-list selling plans
        if (this.sellingPlanLocation === 'below_list') {
          this.updateBelowListSellingPlans(productId);
        }

        console.log('Showing product:', productId);
      }

      updateBelowListSellingPlans(productId) {
        // Find the product data to get its selling plans
        const productElement = this.querySelector(`[data-product-id="${productId}"]`);
        if (!productElement) return;

        // Get the product title to find the corresponding product in the list
        const productTitle = productElement.dataset.productTitle;

        // Find all selling plan containers below the list
        const belowListContainers = this.querySelectorAll('.plan-picker__selling-plans-below');

        belowListContainers.forEach((container) => {
          // Check if the selected product has selling plans
          const productSellingPlans = container.querySelectorAll(`[name*="selling-plan-${productId}"]`);

          if (productSellingPlans.length > 0) {
            console.log('Below-list selling plans available for product:', productId);
          } else {
            console.log('No below-list selling plans found for product:', productId);
          }
        });
      }

      handleProductSellingPlan(productId) {
        // This function is now primarily for handling selling plan changes based on user interaction
        // The initial setup of selling plan hidden fields for a selected product is now handled within showProduct
        const selectedSellingPlan = document.querySelector(`input[name="selling-plan-${productId}"]:checked`);

        if (selectedSellingPlan) {
          const sellingPlanId = selectedSellingPlan.value;
          const productForm = selectedSellingPlan.closest('.product__info-container')?.querySelector('.form');

          if (productForm && sellingPlanId !== '') {
            // Remove any existing selling plan hidden input
            const existingSellingPlanInput = productForm.querySelector('input[name="selling_plan"]');
            if (existingSellingPlanInput) {
              existingSellingPlanInput.remove();
            }

            // Add the hidden input for the selected selling plan
            const hiddenInput = document.createElement('input');
            hiddenInput.type = 'hidden';
            hiddenInput.name = 'selling_plan';
            hiddenInput.value = sellingPlanId;
            productForm.appendChild(hiddenInput);
            console.log('Updated selling plan in form for product:', productId, 'Plan ID:', sellingPlanId);
          }
        }
      }

      handleSellingPlanChange(target) {
        const productId = target.name.replace('selling-plan-', '').replace('-mobile', '');
        const sellingPlanId = target.value;

        console.log('Selling plan changed:', {
          productId: productId,
          sellingPlanId: sellingPlanId,
        });

        // Find the closest product form - this could be in the product info or in the below-list section
        let closest_product_form;

        if (this.sellingPlanLocation === 'below_list') {
          // For below-list selling plans, find the form in the current product group
          const currentProductGroup = this.closest('.product-group');
          if (currentProductGroup) {
            const selectedProduct = currentProductGroup.querySelector('product-info.selected');
            if (selectedProduct) {
              closest_product_form = selectedProduct.querySelector('.product__info-container .form');
            }
          }
        } else {
          // For inside-card selling plans, find the form in the same container
          closest_product_form = target.closest('.product__info-container').querySelector('.form');
        }

        if (!closest_product_form) {
          console.warn('Could not find product form for selling plan change');
          return;
        }

        console.log(closest_product_form);
        // Remove any existing selling plan hidden input
        const existingSellingPlanInput = closest_product_form.querySelector('input[name="selling_plan"]');
        if (existingSellingPlanInput) {
          existingSellingPlanInput.remove();
        }

        // If a selling plan ID is found, add a hidden input to the form
        if (sellingPlanId !== '') {
          const hiddenInput = document.createElement('input');
          hiddenInput.type = 'hidden';
          hiddenInput.name = 'selling_plan';
          hiddenInput.value = sellingPlanId;
          closest_product_form.appendChild(hiddenInput);
        }

        // Here you can add additional logic for selling plan changes
        // For example, updating prices, variants, etc.
      }
    }
  );
}

if (!customElements.get('featured-product-tabs')) {
  customElements.define(
    'featured-product-tabs',
    class FeaturedProductTabs extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('click', this.handleClick.bind(this));
      }

      handleClick(event) {
        const target = event.target.closest('.tabs__header-item-button');
        if (target && target.dataset.flavor) {
          console.log('Clicked flavor:', target.dataset.flavor);
          this.showProductGroup(target.dataset.flavor);
        }
      }

      showProductGroup(groupIndex) {
        const productGroups = document.querySelectorAll('.product-group');
        productGroups.forEach((group) => {
          group.classList.add('hidden');
        });

        const productGroup = document.querySelector(`.product-group-${groupIndex}`);
        if (productGroup) {
          productGroup.classList.remove('hidden');
        }
      }
    }
  );
}
